import React, { useRef, useState } from "react";

interface VideoPlayerProps {
  videoSrc: string;
  thumbnailSrc?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoSrc,
  thumbnailSrc,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current?.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current?.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="relative overflow-hidden group pt-[56.25%] cursor-pointer">
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover lg:object-contain outline-none"
        controls
        poster={thumbnailSrc}
        loop
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 group-hover:backdrop-grayscale-0 flex flex-col gap-y-1 justify-center items-center"
        onClick={togglePlay}
      >
        {!isPlaying ? (
          <img
            src="/images/common/play.svg"
            alt="play"
            className="hidden md:block cursor-pointer h-32 w-32"
          />
        ) : (
          <img
            src="/images/common/pause.svg"
            alt="pause"
            className="cursor-pointer hidden md:group-hover:block h-32 w-32"
          />
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
